"use client";

import React, { useState } from "react";
import { createNowPayment } from "../utils/api/nowpayments";
import { toast } from "react-toastify";
import RailButton from "@/components/ui/RailButton";

export default function NowPaymentsButton({ product, user }) {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const handleClick = async () => {
    try {
      setLoading(true);
      setErr(null);

      const email =
        user?.email ||
        product?.recipient?.email ||
        null;

      const { pay_url } = await createNowPayment({
        product,
        email,
      });

      if (!pay_url) {
        throw new Error("NOWPayments did not return a pay_url");
      }

      window.location.href = pay_url;
    } catch (e) {
      console.error(e);
      const msg = e.message || "Crypto payment failed";
      setErr(msg);
      toast.error(`❌ ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-3 w-full animate-fadeIn">

      <RailButton
        theme="now"                // 🔥 uses rail-now colors from tailwind
        loading={loading}
        onClick={handleClick}
        hint="Lowest fees: choose USDC (Solana)"
        badge="NOWPayments"
      >
        Pay with Crypto (NOWpayments)
      </RailButton>

      {err && (
        <p className="mt-2 text-xs text-red-400 text-center">{err}</p>
      )}
    </div>
  );
}
